import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getReceiveCollectionList(data) {
  return fetch({
    url: '/financial/receive/collection/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单据
 */
export function deleteReceiveCollection(data) {
  return fetch({
    url: '/financial/receive/collection/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function saveReceiveCollection(data) {
  return fetch({
    url: '/financial/receive/collection/save',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/ReceiveCollection/index.js